import * as math from 'mathjs';

// 减
export const subtract = (num1: number, num2: number) => {
  const newNum1 = Number.isNaN(num1) ? 0 : num1;
  const newNum2 = Number.isNaN(num2) ? 0 : num2;

  return math.subtract(math.bignumber(newNum1), math.bignumber(newNum2));
};

// 校验巴西金额输入 allowNegativeNum - 是否支持负数
export const checkMoneyInputBR = (params: any) => {
  const { value, allowNegativeNum = false, maxPrice } = params;
  // 支持 ， .
  let total: string = value.replace(/[，.]/g, ',');

  if (allowNegativeNum) {
    // 可以输入负号，数字和逗号
    total = total.replace(/[^-\d,]/g, '');
    // 确保只有一个负号并且只能出现在开头
    total = total.replace(/(.+)-/g, '$1');
    // 不能逗号开头
    total = total.replace(/^-?,/g, '-0,');
    // 不能多个零开头
    total = total.replace(/^-0+/, '-0').replace(/^0+/, '0');
  } else {
    // 只能输入数字和逗号
    total = total.replace(/[^\d,]/g, '');
    // 不能逗号开头
    total = total.replace(/^,/g, '0,');
    // 不能多个零开头
    total = total.replace(/^0+/, '0');
  }
  // 逗号只能出现一次
  total = total.replace(',', '$#$').replace(/,/g, '').replace('$#$', ',');
  // 只能输入两位小数
  total = total.replace(/^(-)?(\d+),(\d\d).*$/, '$1$2,$3');

  // 校验金额是否超过最大值
  const maxPriceNum = Number(`${maxPrice}`.replace(',', '.'));

  if (Number(total.replace(',', '.')) >= maxPriceNum) {
    total = `${maxPriceNum}`;
  }

  return total;
};
